<template>
    <div class="faq">
        <Modal
                v-model="modalAdd"
                title="新增FAQ"
                :closable="false"
                :mask-closable="false"
                @on-ok="addRecord"
                @on-cancel="">
            <p>问题：</p>
            <Input v-model="addQuestion" placeholder="问题" clearable/>
            <p>答案：</p>
            <Input type="textarea" :autosize="{minRows: 7}" v-model="addAnswer" placeholder="答案" clearable/>
            <Checkbox v-model="isUpdateTime">是否更新时间</Checkbox>
            <p>备注：勾选更新时间展示红点</p>
        </Modal>
        <div class="headers">
            <span>问题分类：</span>
            <Select @on-change="changeSelect" v-model="classify" style="width: 120px">
                <Option v-for="item in filterClassify" :value="item.value" :key="item.value">{{
                    item.label }}
                </Option>
            </Select>
            <Button @click="modalAdd = true">新增</Button>
            <Button @click="sort_btn">{{sort_btn_msg}}</Button>
            <Button v-show="sortSaveBtn" @click="sort_save">保存</Button>
            <Button @click="refreshRecords">刷新</Button>
        </div>
        <Table :columns="columns" :data="data">
            <template slot-scope="{ row, index }" slot="sort">
                <span>{{ row.sort }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="classify">
                <span>{{ row.classify }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="question">
                <template v-if="editIndex === index">
                    <i-Input type="text" v-model="update_question"/>
                </template>
                <span v-else>{{ row.question }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="answer">
                <template v-if="editIndex === index">
                    <i-Input type="textarea" v-model="update_answer"/>
                </template>
                <span v-else class="answer-content">{{ row.answer }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="update_time">
                <template v-if="editIndex === index">
                    <Checkbox v-model="isUpdateTime">是否更新时间</Checkbox>
                </template>
                <span v-else>{{ row.update_time }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="action">
                <div v-if="!sorting">
                    <div v-if="editIndex === index">
                        <Button @click="handleSave(index)" :disabled="action_btn_disabled">保存</Button>
                        <Button style="margin-left: 10px" @click="editIndex = -1" :disabled="action_btn_disabled">取消
                        </Button>
                    </div>
                    <div v-else>
                        <Button @click="handleEdit(row, index)">修改</Button>
                        <Button style="margin-left: 10px" @click="deleteRecord(row, index)">删除</Button>
                    </div>
                </div>
                <div v-else>
                    <Button :disabled="index === 0" style="border-radius: 50%" @click="handel_sort(row,index,'up')">上
                    </Button>
                    <Button :disabled="index === data.length -1" style="border-radius: 50%;margin-left: 5px"
                            @click="handel_sort(row,index,'down')">下
                    </Button>
                </div>
            </template>
        </Table>
    </div>
</template>

<script>
    import apis from "../../http/api";

    export default {
        name: "faq",
        data() {
            return {
                filterClassify: [{label: 'CoStudy简介', value: 0}, {label: '快速入门', value: 1}, {label: '常见问题', value: 2}],
                classify: 0,
                data: [],
                tmpData: [],
                modalAdd: false,
                action_btn_disabled: false,
                sortSaveBtn: false,
                update_question: "",
                update_answer: "",
                update_faq_id: null,
                editIndex: -1,
                sorting: false,
                sortBtnDesc: "排序",
                addQuestion: "",
                addAnswer: "",
                isUpdateTime: false,
                columns: [
                    {
                        title: '序号',
                        slot: 'sort',
                        width: 70
                    },
                    {
                        title: '分类名',
                        slot: 'classify',
                        width: 120
                    },
                    {
                        title: '问题',
                        slot: 'question'
                    },
                    {
                        title: '答案',
                        slot: 'answer'
                    },
                    {
                        title: '更新时间',
                        slot: 'update_time',
                        width: 170
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 180
                    }
                ]
            }
        },
        async created() {
            await this.getRecords()
        },
        watch:{
            // 如果退出编辑将多选框置为false
            editIndex: function (newVal,oldVal) {
                if(newVal === -1){
                    this.isUpdateTime = false
                }
            }
        },
        methods: {
            async refreshRecords() {
                await apis.faq_refresh_records().then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {

                    }
                }).catch(err => {
                })
                await this.getRecords()
            },
            async getRecords() {
                apis.faq_get_records_by_classify(this.classify).then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        this.data = data.records
                    }
                }).catch(err => {

                })
            },
            async addRecord() {
                if(!this.addAnswer){
                    this.$Message.error('答案不能为空');
                    return
                }
                if(!this.addQuestion){
                    this.$Message.error('问题不能为空');
                    return
                }
                let post_data = {
                    classify: this.classify,
                    question: this.addQuestion,
                    answer: this.addAnswer,
                    is_update_time: this.isUpdateTime
                }
                apis.faq_add_record(post_data).then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        console.log('ok')
                        this.addQuestion = ""
                        this.addAnswer = ""
                        this.isUpdateTime = false
                    }
                }).catch(res => {
                })

                await this.refreshRecords()
            },
            updateRecord(index) {
                let post_data = {
                    id: this.data[index].id,
                    question: this.update_question,
                    answer: this.update_answer,
                    is_update_time: this.isUpdateTime
                }
                apis.faq_update_record(post_data).then(res => {
                    this.refreshRecords()
                })
            },
            deleteRecord(row, index) {
                this.data.splice(index, 1)
                let post_data = {
                    id: row.id,
                    classify: this.classify,
                    records: this.data
                }
                apis.faq_delete_record(post_data).then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        this.refreshRecords()
                    }
                }).catch()
            },
            handleEdit(row, index) {
                this.action_btn_disabled = false;
                this.update_question = row.question;
                this.update_answer = row.answer;
                this.update_faq_id = row.id;
                this.editIndex = index;
            },
            handleSave(index) {
                this.action_btn_disabled = true;
                this.updateRecord(index);
                this.editIndex = -1;
            },
            sort_btn() {
                this.sorting = !this.sorting
                this.sortSaveBtn = !this.sortSaveBtn
                if (!this.sorting) {
                    // 深拷贝
                    let tmp = JSON.stringify(this.tmpData)
                    this.data = JSON.parse(tmp)
                } else {
                    // 深拷贝
                    let tmp = JSON.stringify(this.data)
                    this.tmpData = JSON.parse(tmp)
                }
            },
            handel_sort(row, index, action) {
                let index2 = action === "up" ? index - 1 : index + 1;
                let index1 = index;
                this.data[index1] = this.data.splice(index2, 1, this.data[index1])[0]
            },
            sort_save() {
                this.sorting = !this.sorting
                this.sortSaveBtn = !this.sortSaveBtn
                let post_data = {
                    records: this.data,
                    classify: this.classify
                }
                apis.faq_sort_records(post_data).then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        this.refreshRecords()
                    }
                })
            },
            async changeSelect() {
                await this.getRecords()
            }
        },
        computed: {
            sort_btn_msg() {
                return this.sorting ? "取消" : "排序"
            }
        }
    }
</script>

<style scoped>
    .faq {
        margin: 10px;
    }

    .headers {
        text-align: center;
        margin-bottom: 10px;
    }

    .headers Button {
        margin-left: 10px;
    }

    .answer-content {
        white-space: pre-wrap;
    }

</style>